import './styles.scss'

import React, { useEffect, useCallback } from 'react'
import { useActions, useValues } from 'kea'
import { hot } from 'react-hot-loader'

import I18n from 'lib/i18n'
import FullScreen from 'lib/components/full-screen'

import FirstPage from './first-page'
import CategoryLocation from './category-location'
import StudentAge from './student-age'
import StartTime from './start-time'
import { ConnectedAvailability as Availability } from './availability'
import Frequency from './frequency'
import LocationType from './location-type'
import RequestRequest from './request'
import ThankYou from './thank-you'

import sceneLogic from '~/scenes/pages/request/logic'

const Request = () => {
  const { nextPage, previousPage } = useActions(sceneLogic)
  const { progressPercentage, pageKeyword, pageIsValid, isSubmitting, openedModalAfterSubmit } = useValues(sceneLogic)

  const handleExit = useCallback(
    event => {
      if (!openedModalAfterSubmit && !isSubmitting && pageKeyword !== 'first-page' && pageKeyword !== 'thank-you') {
        event.returnValue = I18n.t('react.request.exit_warning')
        return I18n.t('react.request.exit_warning')
      }
    },
    [isSubmitting, openedModalAfterSubmit, pageKeyword]
  )

  useEffect(() => {
    window.addEventListener('beforeunload', handleExit)

    return () => {
      window.removeEventListener('beforeunload', handleExit)
    }
  }, [handleExit])

  const handlePreviousPage = event => {
    event.preventDefault()
    event.target.blur()
    previousPage()
  }

  const handleNextPage = event => {
    event.preventDefault()
    event.target.blur()
    nextPage()
  }

  return (
    <div className={`pages-request-scene page-${pageKeyword}`}>
      {pageKeyword !== 'first-page' && pageKeyword !== 'thank-you' && <FullScreen />}
      {pageKeyword !== 'first-page' && (
        <div className='request-progress'>
          <div className='progress' style={{ width: `${progressPercentage}%` }} />
        </div>
      )}
      <div className='question-area'>
        {pageKeyword === 'first-page' ? (
          <FirstPage />
        ) : (
          <div className='question'>
            {pageKeyword === 'category-location' && <CategoryLocation />}
            {pageKeyword === 'student-age' && <StudentAge />}
            {pageKeyword === 'start-time' && <StartTime />}
            {pageKeyword === 'availability' && <Availability isRequestTeacherPage />}
            {pageKeyword === 'frequency' && <Frequency />}
            {pageKeyword === 'location-type' && <LocationType />}
            {pageKeyword === 'request' && <RequestRequest />}
            {pageKeyword === 'thank-you' && <ThankYou />}
            {pageKeyword !== 'category-location' && pageKeyword !== 'request' && pageKeyword !== 'thank-you' && (
              <div className='navigation'>
                {pageKeyword !== 'request' &&
                  (pageIsValid ? (
                    <button title={I18n.t('react.request.next')} className='forward' onClick={handleNextPage}>
                      {I18n.t('react.request.next')}
                    </button>
                  ) : (
                    <button title={I18n.t('react.request.skip')} className='forward disabled' onClick={handleNextPage}>
                      {I18n.t('react.request.skip')}
                    </button>
                  ))}
                <a className='back' title={I18n.t('react.request.back')} href='#' onClick={handlePreviousPage}>
                  {I18n.t('react.request.back')}
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default hot(module)(Request)
